import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { ContactUsService } from '../contact-us/contact-us.service';

@Component( {
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.css']
} )
export class ContactUsComponent implements OnInit {
    public fixed = false;
    contactForm = new FormGroup( {
        firstName: new FormControl( '' ),
        lastName: new FormControl(),
        phoneNumber: new FormControl( '' ),
        company: new FormControl(),
        email: new FormControl(),
        message: new FormControl()
    } );

    constructor( private cookieService: CookieService, private route: ActivatedRoute, private router: Router,
                 private contactservice: ContactUsService ) {
    }

    ngOnInit() {
    }

//   onWindowScroll() {
//     let num = this.doc.body.scrollTop;
//     if ( num > 50 ) {
//         this.fixed = true;
//     }else if (this.fixed && num < 5) {
//         this.fixed = false;
//     }
//  }

}
